var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgArrowLeftAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.903 10.512h-6.95a.15.15 0 0 1-.103-.258l2.313-2.228a1.562 1.562 0 0 0-.045-2.204 1.564 1.564 0 0 0-2.203-.046l-5.863 5.807a.599.599 0 0 0-.005.845l5.763 5.822A1.593 1.593 0 0 0 13.058 16l-2.232-2.235a.15.15 0 0 1 .105-.255h6.99c.931 0 1.197-1.003 1.197-1.503a1.365 1.365 0 0 0-1.215-1.495Z",
  fill: "currentColor"
})));

export default SvgArrowLeftAlt;